const ENV = import.meta.env.VITE_PORTAL_ENV;

const COPY: Record<string, string> = {
  staging: "Staging environment — not the production portal. Data is disposable.",
  development: "Development environment — running locally.",
};

export function EnvironmentBanner() {
  const message = COPY[ENV];
  if (!message) return null;

  return (
    <div
      role="status"
      className="fixed inset-x-0 top-0 z-50 flex h-7 items-center justify-center border-b border-[#8a6e1f] bg-[#c9a227] text-[11.5px] font-medium tracking-wide text-[#1a1a1a]"
    >
      <span className="mr-2 inline-flex items-center rounded-sm bg-[#1a1a1a] px-1.5 py-0.5 text-[9.5px] font-semibold uppercase tracking-wider text-[#c9a227]">
        {ENV}
      </span>
      {message}
    </div>
  );
}

export const ENV_BANNER_VISIBLE = Boolean(COPY[ENV]);
